<div :class="[$style.imageContainer]" v-if="imageURL.length > 0">
  <img :class="[$style.imageSize]" :id="$vId(this, 'promo-img')" :src="imageURL"/>
  <svg 
    @click="removePromoImageStore"
    :class="$style.svgRemove" 
    width="30" height="30" 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6573 2.34318L2.34355 13.6569" stroke="#2196F3" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M2.34274 2.34318L13.6564 13.6569" stroke="#2196F3" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</div>
